module.exports = __webpack_public_path__ + "static/media/emily-willis-win.35a45471.jpg";